import { AccountLabel } from "./Account.model";

export enum DraftStatus {
    COMMITTED = "committed",
    IN_PROGRESS = "in_progress",
}

export enum AccountHintType {
    EXISTING = "existing",
    NEW = "new",
}

export type DraftAccountMeta = {
    codatAccountId?: string | null;
    matchMeta?: any | null;
    reason?: string | null;
};

export type DraftAccount = {
    type: AccountHintType;
    accountId?: string | undefined;
    label: AccountLabel;
    accountName: string;
    meta?: DraftAccountMeta | null;
} | null;

export type IdentifierSource = "codat" | "file";

export interface Draft {
    id: string;
    status: DraftStatus;
    fileId: string;
    fileName: string;
    connectorId: string;
    identifierSource: IdentifierSource;
    documentType: string;
    statementType: string;
    companyId: string;
    ownerId: string | null;
    createdAt: string;
    updatedAt: string;
    periods: string[];
    rows: Record<
        string,
        {
            account: DraftAccount;
            rowHeader: string;
            values: Array<{
                period: string;
                value: number;
                identifier: {
                    identifier: string;
                };
                expressions: any[];
            }>;
        }
    >;
}

export interface DraftSnapshot {
    id: string;
    status: DraftStatus;
    fileId: string;
    createdBy: string | null;
    createdAt: string;
    committedAt?: string | null;
}

export interface DraftValidation {
    completeness: {
        status: "warning" | "fail" | "pass" | "loading";
        messages: string[];
    };
    accountNaming: {
        status: "warning" | "fail" | "pass" | "loading";
        messages: Array<{
            rowId: string;
            message: string;
        }>;
    };
}

export type DraftRow = Draft["rows"][string];
export type DraftRowEdit = Partial<DraftRow>;
export type DraftEdits = { rows?: Record<string, DraftRowEdit> };
